import Mentions from "../../components/Mentions/mentions"

function Mention (){
    return(
        <Mentions/>
    )}

    export default Mention